import { render, staticRenderFns } from "./PeriodicityAndDates.vue?vue&type=template&id=5fe75e74&scoped=true"
import script from "./PeriodicityAndDates.vue?vue&type=script&lang=js"
export * from "./PeriodicityAndDates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe75e74",
  null
  
)

export default component.exports